/**
 * Entrada pelo Auth MANAGER, atraves do backend do manager - nao pelo Reader que o viewer usa.
 *
 * O backend faz duas coisas no `POST /auth/login`: pega o token no Auth e **valida o portao admin**
 * (`validate_admin_token`). Por isso existem dois erros diferentes: 401 e credencial invalida, 403
 * `admin_access_denied` e credencial valida sem permissao de admin.
 *
 * O `/auth/me` responde com ENVELOPE (`{affected_rows, rows}`); o `/auth/login`, direto. Conferido
 * em `backend/app/api/routes/auth.py`, nao deduzido.
 */

import { apiGet, apiPost, type Envelope } from '../api/client'
import type { LoginResult, Me, Permissoes } from '../api/types'

export function login(email: string, password: string): Promise<LoginResult> {
  return apiPost<LoginResult>('/auth/login', { email, password })
}

export async function fetchMe(): Promise<Me> {
  const resposta = await apiGet<Envelope<Me>>('/auth/me')
  const primeiro = resposta.rows[0]
  if (primeiro === undefined) throw new Error('sessao sem usuario')
  return primeiro
}

/**
 * Capacidades da sessao, por modulo. Falha nao derruba a tela: sem resposta, a interface assume
 * que nao pode nada e o backend continua sendo quem decide - esconder demais e recuperavel,
 * mostrar um botao que vai dar 403 nao e.
 */
export async function fetchPermissoes(): Promise<Permissoes> {
  const resposta = await apiGet<Envelope<Permissoes>>('/auth/permissions')
  const primeira = resposta.rows[0]
  if (primeira === undefined) throw new Error('sessao sem permissoes')
  return primeira
}
